import { paginationSize } from '../../../constants/constants';
import { ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS, FETCH_NEW_USER_CASES_ERROR, FETCH_NEW_USER_CASES_START, FETCH_NEW_USER_CASES_SUCCESS, NEW_CASES_PAGINATION } from '../../actions/NewCasesAction';
import _ from 'lodash';

const INIT_STATE = {
    newCases: [],
    loading: false,
    message: '',
    error: '',
    newCasesPagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0
    },

}

export const newCasesReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_NEW_USER_CASES_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_NEW_USER_CASES_SUCCESS:
            return { ...state, error: '', message: '', loading: false, newCases: action.newCases.length > 0 ? [...action.newCases] : [] }

        case FETCH_NEW_USER_CASES_ERROR:
            return { ...state, loading: false, error: '', newCases: [] }

        case NEW_CASES_PAGINATION: {
            return { ...state, newCasesPagination: { ...action.pagination } };
        }

        case ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS: {
            let newState = _.cloneDeep(state);
            newState.newCases.push(action.userCase);
            return { ...newState };
        }
        default:
            return state;
    }
}
export default newCasesReducer;